<template>
  <b-card
    class="complaint"
    no-body
  >
    <b-card-body>
      <b-card-title>Complaint</b-card-title>
      <table class="props">
        <tr>
          <th>Club</th>
          <td>
            <club-link :clubId="complaint.clubId" />
          </td>
        </tr>
        <tr>
          <th>Reporter</th>
          <td>
            <player-link :playerId="complaint.reporterId" />
          </td>
        </tr>
        <tr>
          <th>Reported</th>
          <td>
            {{complaint.ctime | getMomentStr}}
          </td>
        </tr>
      </table>

      <b-card-text>
        <span
          v-b-popover.hover.top="'Message publication time'"
        >
          {{complaint.msgCtime | getMomentStr}}
        </span>
        <br>
        {{complaint.msgText}}
      </b-card-text>

    </b-card-body>
    
    <b-card-footer
      v-if="mayEditPlayerData"
    >
      <b-button @click='handleRejectionSelection'>
        Reject
      </b-button>
    </b-card-footer>
  </b-card>
</template>

<script>
import auth from '../auth';
import ClubLink from './ClubLink.vue';
import PlayerLink from './PlayerLink.vue';
import { mayEditPlayerData as utilMayEditPlayerData } from '../util';

export default {
  name: 'RejectableComplaint',

  components: {
    ClubLink,
    PlayerLink,
  },

  props: {
    complaint: {
      type: Object,
      required: true,
    }
  },

  data() {
    return {
      actor: auth.getViewer(),
    };
  },

  computed: {
    mayEditPlayerData() {
      return utilMayEditPlayerData(this.actor.role);
    },
  },

  methods: {
    handleRejectionSelection() {
      this.$emit('rejection-selected', this.complaint);
    },
  },
};
</script>

<style scoped>
  .card {
    margin-bottom: 2em;
  }

  .complaint .props {
    margin-bottom: 1em;
  }

  .props th {
    padding-right: 1em;
    white-space: nowrap;
  }
</style>
